import { CHURCH } from '../config/church'
import type { Screen } from '../core/types'
import { homeBar, pageHeader } from './chrome'

export function createDirectionsScreen(): Screen {
  return {
    mount(root, ctx) {
      root.classList.add('screen--page')
      root.appendChild(pageHeader('오시는 길', '주소와 연락처'))

      const body = document.createElement('div')
      body.className = 'page__body'

      const rows: Array<[string, string]> = [
        ['주소', CHURCH.address],
        ['전화', CHURCH.tel],
        ['홈페이지', CHURCH.site],
      ]

      for (const [label, value] of rows) {
        const block = document.createElement('div')
        block.className = 'detail-row'

        const key = document.createElement('p')
        key.className = 'detail-row__label'
        key.textContent = label

        const text = document.createElement('p')
        text.className = 'detail-row__value'
        text.textContent = value

        block.append(key, text)
        body.appendChild(block)
      }

      // TODO: a static map image (Cloudflare Images or an R2-hosted export).
      // Deliberately not an embedded live map — a kiosk browser should not hand
      // visitors a pannable third-party surface they can get lost inside.
      const mapNote = document.createElement('p')
      mapNote.className = 'empty'
      mapNote.textContent = '약도 이미지는 준비 중입니다.'
      body.appendChild(mapNote)

      root.appendChild(body)
      root.appendChild(homeBar(ctx.go))
    },
  }
}
